import moveReadingPaneToTab from './moveReadingPaneToTab';
import ConversationReadingPaneViewState from '../store/schema/ConversationReadingPaneViewState';
import readingPaneStore from '../store/Store';
import { findInlineComposeViewState } from 'owa-mail-compose-actions';
import { InstrumentationContext } from 'owa-mail-store';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action, select } from 'satcheljs/lib/legacy';

export interface HandleCurrentlyOpenInlineComposeState {
    conversationReadingPaneState: ConversationReadingPaneViewState;
}

export default action('handleCurrentlyOpenInlineCompose')(
    select<HandleCurrentlyOpenInlineComposeState>({
        conversationReadingPaneState: () => readingPaneStore.conversationReadingPaneViewState,
    })(function handleCurrentlyOpenInlineCompose(
        instrumentationContext: InstrumentationContext,
        state?: HandleCurrentlyOpenInlineComposeState
    ) {
        if (state.conversationReadingPaneState) {
            const composeViewState = findInlineComposeViewState(
                state.conversationReadingPaneState.conversationId.Id
            );
            if (composeViewState) {
                moveReadingPaneToTab(
                    state.conversationReadingPaneState.conversationId,
                    state.conversationReadingPaneState.conversationSubject,
                    state.conversationReadingPaneState.conversationCategories,
                    false /* makeActive */,
                    instrumentationContext,
                    ReactListViewType.Conversation
                );

                readingPaneStore.conversationReadingPaneViewState = null;
            }
        }
    })
);
